export const SORT_TYPES = {

    "EWS_SCORE": "EWS_SCORE",
    "FAVORITE": "FAVORITE"
}

export const VIEW_TYPES = {

    "GRID_VIEW": "GRID_VIEW",
    "LIST_VIEW": "LIST_VIEW"
}

export const DISCHARGE_STATUS = [
    { name: 'Cured', label: 'Cured' },
    { name: 'Transfer to other hospital', label: 'Transfer to other hospital' },
    { name: 'Transfer to different ward', label: 'Transfer to different ward' },
    { name: 'Discharged at request', label: 'Discharged at request' },
    { name: 'Discharged against medical advice', label: 'Discharged against medical advice' },
    { name: 'Death', label: 'Death' },
]

export const ADD_NOTE_SELECT = [
    // { name: 'Initial Assessment Performa', label: 'Initial Assessment Performa', id: 1 },
    // { name: 'Progress Notes', label: 'Progress Notes', id: 2 },
    { name: 'General Note', label: 'General Note', id: 3 }
]

export const ADD_NOTE_OPTIONS = {
    // INITIAL_ASSESSMENT: 'Initial Assessment Performa',
    // PROGRESS_NOTE: 'Progress Notes',
    GENERAL_NOTE: 'General Note'
}

export const SIDEBAR_ICON = {
    PATIENT_BOOK: "PATIENT_BOOK",
    HOME_PAGE: "HOME_PAGE",
}

export const DUMMY_PATIENT = {
    NAME: "Dummy Patient",
    UHID: "00000"
}

export const CHARTING_OPTION = {
    CLINICAL_SCORES: "Clinical Scores",
    OTHER: 'Other',
}

export const VITAL_VIEW_MODES = [
    { name: "NUMERIC_DATA", label: "Numeric Data" },
    { name: "GRAPH", label: "Graph" },

]

export const VITAL_VIEW_CONTANTS = {
    GRAPH: "Graph",
    NUMERIC_DATA: "Numeric Data",
    TODAY: "Today",
    LAST_24_HOURS: "Last 24 Hours",
    CUMMULATIVE: "Cumulative"
}

export const VITAL_GRAPH_VIEW_PARAM = {
    nibpM: 'NIBP (M)',
    nibpD: 'NIBP (D)',
    nibpS: 'NIBP (S)',
    hr: 'HR',
    pr: 'PR',
    rr: 'RR',
    spo2: 'SpO₂',
    temp: 'TEMP'
}

export const FILTER_TYPES = {

    FAVORITE: "FAVORITE"
}
export const SCORE_COLOR = {
    YELLOW: 'yellow',
    RED: 'red',
    GREEN: 'green'
}
export const USER_ROLE = {
    DOCTOR: 'DOCTOR',
    NURSE: 'NURSE',
}

export const PAGE_PARENT = {
    PATIENT_MODAL: "PATIENT_MODAL",
    BED_DETAIL: "BED_DETAIL"
}

export const ADD = "ADD";
export const REMOVE = "REMOVE";

export const TIMELINE = {
    GRAPH_ARRAY: ["LIVE", "4H", "8H", "12H", "24H"],
    LIVE: "LIVE"
}

export const CELCIUS_DEGREE_CODE = '&#8451';

export const EWS_SCORE = {
    NO_RISK: {
        LABEL: "NO RISK",
        VALUE: "no_risk",
    },
    MILD_RISK: {
        LABEL: "MILD RISK",
        VALUE: "mild_risk",
    },
    CRITICAL: {
        LABEL: "CRITICAL",
        VALUE: "critical",
    }
}

export const CLINICAL_SCORE_ACTIVE_DATE = 'CLINICAL_SCORE_ACTIVE_DATE';

export const BLOOD_GROUP_OPTION = [
    { name: "A+", label: "A+" },
    { name: "A-", label: "A-" },
    { name: "O+", label: "O+" },
    { name: "B+", label: "B+" },
    { name: "O-", label: "O-" },
    { name: "B-", label: "B-" },
    { name: "AB-", label: "AB-" },
    { name: "AB+", label: "AB+" },
]

export const MODAL_ITEMS = {
    CHARTING: 'Charting',
    NURSE_NOTES: 'Nurse Notes',
    DOCTOR_NOTES: 'Doctor Notes',
    PRESCRIPTION: 'Prescription',
    ALARM_HISTORY: 'Alarm History'
}

export const CHART_OPTIONS = {
    VITALS: 'Vitals',
    RS: "RS",
    CVS: 'CVS',
    CNS: 'CNS',
    NURSING_CHECKS: 'Nursing Checks',
    I_O_BAL: 'I/O Bal',
    DRUG_ADMINISTRATION: "Drug Administration",
    // LAB_REPORTS: "Lab Reports",
    CLINICAL_SCORES: "Clinical Scores",
    BUNDLES: "Bundles",
    LINES: "Lines",
}

export const CHART_TABLE_OPTIONS = [
    // CHART_OPTIONS.VITALS,
    CHART_OPTIONS.RS,
    CHART_OPTIONS.CVS,
    CHART_OPTIONS.CNS,
    CHART_OPTIONS.NURSING_CHECKS,
];

export const NOTES_TYPE = {
    DOCTOR: "DOCTOR",
    NURSE: "NURSE"
}

export const PRESCRIPTION_OPTIONS = {

    DRUGS: "Drugs",
    INFUSION: "Infusion",
    STAT_ORDERS: "Stat Orders"
}

export const LINES_ACTIONS = {
    CONTINUE: 'CONTINUE',
    REMOVE: 'REMOVE',
}
export const BED_DETAILS_MODULE = {
    PATIENT_DETAILS: "Patient Details",
    MONITOR: "Monitor",
    VENTILATOR: "Ventilator",
    ALARMS: "Alarm History",
    TRENDS_REPORTS: "Trends & Reports",
    NURSE_NOTES: "Nurse Notes",
    DOCTOR_NOTES: "Doctor Notes",
    CHARTING: "Charting",
    PRESCRIPTION: "Prescription"
}

export const LINES_DROPDOWN_OPTIONS = [
    { name: 'ARTERIAL_LINE', label: 'Arterial Line(A-line)' },
    { name: 'CENTRAL_VENOUSE_CATHETER', label: 'Central venous catheter' },
    { name: 'CHEST_TUBE', label: 'Chest tube' },
    { name: 'COLOSTOMY_OSTOMY_POUCH', label: 'Colostomy ostomy pouch' },
    { name: 'DRAIN', label: 'Drain' },
    { name: 'EAR_TUBE', label: 'Ear tube' },
    { name: 'ENDOTRACHEAL_TUBE', label: 'Endotracheal tube' },
    { name: 'EXTENAL_VENTRICULAR_DRAINS', label: 'External Ventricular Drains' },
    { name: 'HEMODIALYSIS_CENTRAL_VENOUS', label: 'Hemodialysis Central venous catheter (HD-CVC)' },
    { name: 'INTERCOSTAL_DRAINAGE_TUBE', label: 'Intercostal Drainage tube' },
    { name: 'LUMBAR_DRAIN', label: 'Lumbar Drain' },
    { name: 'NASOGASTRIC_TUBE', label: 'Nasogastric Tube' },
    { name: 'OROGASTRIC_TUBE', label: 'Orogastric Tube' },
    { name: 'PERCUTANEOUS_ENDOSCOPIC_GASTROSTOMY_TUBE', label: 'Percutaneous Endoscopic Gastrostomy tube' },
    { name: 'PERCUTANEOUS_ENDOSCOPIC_JEJUNOSTOMY_TUBE', label: 'Percutaneous Endoscopic Jejunostomy tube' },
    { name: 'PERCUTANEOUS_NEPHROSTOMY_TUBE', label: 'Percutaneous nephrostomy tube' },
    { name: 'PERCUTANEOUS_URETEROSTOMY_TUBE', label: 'Percutaneous ureterostomy tube' },
    { name: 'PERIPHERAL_IV_CATHETER', label: 'Peripheral IV catheter' },
    { name: 'PICC', label: 'PICC' },
    { name: 'PULMONARY_ARTERY_CATHETER_SWAN_GANZ', label: 'Pulmonary artery catheter(Swan-Ganz)' },
    { name: 'SENGSTAKEN_BLAKEMORE_TUBE', label: 'Sengstaken-Blakemore tube' },
    { name: 'SUPRAPUBIC_CATHETER', label: 'Suprapubic catheter' },
    { name: 'TRACHEOSTOMY_TUBE', label: 'Tracheostomy tube' },
    { name: 'TUNNELED_CENTRAL_VENOUS_CATHETER', label: 'Tunneled central venous catheter' },
    { name: 'URINARY_CATHETER', label: 'Urinary catheter' },
    { name: 'VAS_PORT_A_CATH', label: 'VAS(or Port-A-Cath)' },
    { name: 'VENTRICULOPERITONEAL_SHUNT', label: 'Ventriculoperitoneal Shunt' },
    { name: 'WOUND_VACS', label: 'Wound VACs' }
]

export const TRIGGER = {
    RIGHT: "RIGHT",
    LEFT: "LEFT"
}

export const DEVICE_TYPES = {
    "VENTILATOR": "VENTILATOR",
    "MONITOR": "MONITOR"
}

export const VENTILATOR_PARAM_LIST = [
    {
        name: 'pressure',
        html: {
            name: 'P',
            nameSuccessor: '',
            nameSub: 'insp',
            sub: 'cmH',
            subSuccessor: 'O',
            subSub: '2'
        }
    },
    {
        name: 'peep',
        html: {
            name: 'PEEP',
            nameSuccessor: '',
            nameSub: '',
            sub: 'cmH',
            subSuccessor: 'O',
            subSub: '2'
        }
    },
    {
        name: 'pPlateau',
        html: {
            name: 'P',
            nameSuccessor: '',
            nameSub: 'plat.',
            sub: 'cmH',
            subSuccessor: 'O',
            subSub: '2'
        }
    },
    {
        name: 'vti',
        html: {
            name: 'V',
            nameSuccessor: '',
            nameSub: 'ti',
            sub: 'ml',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'vte',
        html: {
            name: 'V',
            nameSuccessor: '',
            nameSub: 'te',
            sub: 'ml',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'fio2',
        html: {
            name: 'FiO',
            nameSuccessor: '',
            nameSub: '2',
            sub: '%',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'rr',
        html: {
            name: 'RR',
            nameSuccessor: '',
            nameSub: 'bpm',
            sub: '%',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'ie',
        html: {
            name: 'I:E',
            nameSuccessor: '',
            nameSub: '',
            sub: '-',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'mve',
        html: {
            name: 'MV',
            nameSuccessor: '',
            nameSub: 'e',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'mvi',
        html: {
            name: 'MV',
            nameSuccessor: '',
            nameSub: 'i',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'spontmve',
        html: {
            name: 'Spont. MV',
            nameSuccessor: '',
            nameSub: 'e',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'leakvol',
        html: {
            name: 'Leak Vol',
            nameSuccessor: '',
            nameSub: '',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'rsbi',
        html: {
            name: 'RSBI',
            nameSuccessor: '',
            nameSub: '',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'cstat',
        html: {
            name: 'C',
            nameSuccessor: '',
            nameSub: 'stat',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'cdyn',
        html: {
            name: 'C',
            nameSuccessor: '',
            nameSub: 'dyn',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'ti',
        html: {
            name: 'T',
            nameSuccessor: '',
            nameSub: 'i',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'te',
        html: {
            name: 'T',
            nameSuccessor: '',
            nameSub: 'e',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    },
    {
        name: 'pmean',
        html: {
            name: 'P',
            nameSuccessor: '',
            nameSub: 'mean',
            sub: '',
            subSuccessor: '',
            subSub: ''
        }
    }
];

export const CHART_HEADER_CONST = {
    PARAMETERS: "PARAMETERS",
    MORNING: "MORNING",
    EVENING: "EVENING",
    NIGHT: "NIGHT",
    TYPE: "TYPE",
    REMARKS: "REMARKS",
    ADDITIVES: "ADDITIVES",
    START_TIME: "START TIME",
    DESCRIPTION: "DESCRIPTION"
}

export const IO_DATA = {
    IO_COLUMNS: {
        OUTPUT_TOTAL: "outputTotal",
        DRAIN: "DRAIN",
        URINE: "URINE",
        IV_FLUID: "IV_FLUID",
        INFUSION: "INFUSION",
        ORAL_RT: "ORAL_RT",
        OTHERS: "OTHER",
        INTAKE_TOTAL: "intakeTotal",
        INTAKE: "INTAKE",
        OUTPUT: "OUTPUT",
        TI_TO: "TI_TO",
        BALANCE: "BALANCE",
        TIME: "TIME"
    },
    IO_ROWS: {
        NAME: "NAME *",
        TOTAL: "TOTAL",
        TIME: "TIME"
    }
}

export const getModeFromIOColumn = (columnName) => {

    switch (columnName) {
        case IO_DATA.IO_COLUMNS.OUTPUT_TOTAL:
        case IO_DATA.IO_COLUMNS.DRAIN:
        case IO_DATA.IO_COLUMNS.URINE:
            return IO_DATA.IO_COLUMNS.OUTPUT;
        case IO_DATA.IO_COLUMNS.IV_FLUID:
        case IO_DATA.IO_COLUMNS.INFUSION:
        case IO_DATA.IO_COLUMNS.ORAL_RT:
        case IO_DATA.IO_COLUMNS.OTHERS:
        case IO_DATA.IO_COLUMNS.INTAKE_TOTAL:
            return IO_DATA.IO_COLUMNS.INTAKE;
        case IO_DATA.IO_COLUMNS.TI_TO:
            return IO_DATA.IO_COLUMNS.BALANCE;
    }
}

export const DRUG_ADMINISTRATION_TYPE = {
    INFUSION: "INFUSION",
    DRUG: "DRUG",
    STAT: "STAT"
}

export const getDrugAdministrationHeader = (type) => {
    switch (type) {
        case DRUG_ADMINISTRATION_TYPE.INFUSION:
            return [CHART_HEADER_CONST.PARAMETERS, CHART_HEADER_CONST.ADDITIVES,
            CHART_HEADER_CONST.REMARKS, CHART_HEADER_CONST.START_TIME,
                "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00",
                "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "00:00", "01:00",
                "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];
        case DRUG_ADMINISTRATION_TYPE.DRUG:
            return [CHART_HEADER_CONST.PARAMETERS,
            CHART_HEADER_CONST.REMARKS, CHART_HEADER_CONST.START_TIME,
                "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00",
                "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "00:00", "01:00",
                "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];
        case DRUG_ADMINISTRATION_TYPE.STAT:
            return [CHART_HEADER_CONST.PARAMETERS,
            CHART_HEADER_CONST.REMARKS, CHART_HEADER_CONST.START_TIME,
                "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00",
                "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "00:00", "01:00",
                "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];
        default:
            return []
    }
}

export const getChartHeader = (type) => {

    switch (type) {
        case CHART_OPTIONS.VITALS:
            return [CHART_HEADER_CONST.PARAMETERS, "08:00", "09:00", "10:00", "11:00", "12:00",
                "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00",
                "22:00", "23:00", "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];
        case CHART_OPTIONS.RS:
            return [CHART_HEADER_CONST.PARAMETERS, "08:00", "09:00", "10:00", "11:00", "12:00",
                "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00",
                "22:00", "23:00", "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];
        case CHART_OPTIONS.CVS:
            return [CHART_HEADER_CONST.PARAMETERS, "08:00", "09:00", "10:00", "11:00", "12:00",
                "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00",
                "22:00", "23:00", "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];
        case CHART_OPTIONS.CNS:
            return [CHART_HEADER_CONST.PARAMETERS, "08:00", "09:00", "10:00", "11:00", "12:00",
                "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00",
                "22:00", "23:00", "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];
        case CHART_OPTIONS.NURSING_CHECKS:
            return [CHART_HEADER_CONST.PARAMETERS, CHART_HEADER_CONST.MORNING, CHART_HEADER_CONST.EVENING, CHART_HEADER_CONST.NIGHT];
        case CHART_OPTIONS.BUNDLES:
            return [CHART_HEADER_CONST.DESCRIPTION, CHART_HEADER_CONST.MORNING, CHART_HEADER_CONST.EVENING, CHART_HEADER_CONST.NIGHT];
        case CHART_OPTIONS.DRUG_ADMINISTRATION:
            return [CHART_HEADER_CONST.PARAMETERS,
            // CHART_HEADER_CONST.TYPE, 
            CHART_HEADER_CONST.REMARKS, CHART_HEADER_CONST.START_TIME,
                "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00",
                "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "00:00", "01:00",
                "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];
        case CHART_OPTIONS.CLINICAL_SCORES:
            return [CHART_HEADER_CONST.PARAMETERS, "08:00", "09:00", "10:00", "11:00", "12:00",
                "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00",
                "22:00", "23:00", "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00"];

        case CHART_OPTIONS.I_O_BAL:
            return [
                [
                    {
                        id: "1",
                        label: "TIME",
                        name: IO_DATA.IO_COLUMNS.TIME,
                        className: "time sticky-left border-right",
                        rowSpan: "2",
                        colSpan: "1",
                        isAddIconVisible: false
                    }, {
                        id: "2",
                        label: "INTAKE",
                        name: IO_DATA.IO_COLUMNS.INTAKE,
                        className: "intake",
                        rowSpan: "1",
                        colSpan: "5",
                        isAddIconVisible: false,
                    }, {
                        id: "3",
                        label: "OUTPUT",
                        name: IO_DATA.IO_COLUMNS.OUTPUT,
                        className: "output",
                        rowSpan: "1",
                        colSpan: "3",
                        isAddIconVisible: false,
                    }, {
                        id: "4",
                        label: "BALANCE",
                        name: IO_DATA.IO_COLUMNS.BALANCE,
                        className: "balance sticky-right border-left",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: false,
                    }
                ],
                [
                    {
                        id: "5",
                        label: "IV FLUIDS",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.IV_FLUID),
                        name: IO_DATA.IO_COLUMNS.IV_FLUID,
                        className: "iv_fluids",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: true,
                    }, {
                        id: "6",
                        label: "INFUSIONS",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.INFUSION),
                        name: IO_DATA.IO_COLUMNS.INFUSION,
                        className: "infusions",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: true,
                    }, {
                        id: "7",
                        label: "ORAL/RT",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.ORAL_RT),
                        name: IO_DATA.IO_COLUMNS.ORAL_RT,
                        className: "oral_rt",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: true,
                    }, {
                        id: "8",
                        label: "OTHERS",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.OTHERS),
                        name: IO_DATA.IO_COLUMNS.OTHERS,
                        className: "others",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: true,
                    }, {
                        id: "9",
                        label: "TOTAL",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.INTAKE_TOTAL),
                        name: IO_DATA.IO_COLUMNS.INTAKE_TOTAL,
                        className: "total",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: true,
                    }, {
                        id: "10",
                        label: "URINE",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.URINE),
                        name: IO_DATA.IO_COLUMNS.URINE,
                        className: "urine",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: true,
                    }, {
                        id: "11",
                        label: "DRAIN",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.DRAIN),
                        name: IO_DATA.IO_COLUMNS.DRAIN,
                        className: "drain",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: true,
                    }, {
                        id: "12",
                        label: "TOTAL",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.OUTPUT_TOTAL),
                        name: IO_DATA.IO_COLUMNS.OUTPUT_TOTAL,
                        className: "total",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: true,
                    }, {
                        id: "13",
                        label: "Total Input - Total Output",
                        mode: getModeFromIOColumn(IO_DATA.IO_COLUMNS.TI_TO),
                        name: IO_DATA.IO_COLUMNS.TI_TO,
                        className: "ti-to sticky-right border-left",
                        rowSpan: "1",
                        colSpan: "1",
                        isAddIconVisible: false,
                    }
                ]
            ];

        default:
            return [];
    }
}

export const getAlarmHeader = () => {
    return ["PRIORITY", "ALARM", "VALUE", "DATE", "TIME", "ACTION"];
}

export const BUNDLES_OPTION = {
    VAP: 'VAP',
    CAUTI: 'CAUTI',
    CLABSI: 'CLABSI'
}

export const getBundlesParamList = (type) => {
    switch (type) {
        case BUNDLES_OPTION.VAP:
            return [
                {
                    "label": "Head elevation 30-45",
                    "name": "headElevation",
                    "type": "checkbox",
                    "id": "1"
                },
                {
                    "label": 'Daily "Sedation vacation" and assessment of readiness to wean',
                    "name": "dailySedationVacation",
                    "type": "checkbox",
                    "id": "2"
                },
                {
                    "label": 'Peptic ulcer prophylaxis (PUD)',
                    "name": "pepticUlcerprophylaxis",
                    "type": "checkbox",
                    "id": "3"
                },
                {
                    "label": 'Deep Venous Thrombosis (DVT) prophylaxis',
                    "name": "deepVenousThrombosis",
                    "type": "checkbox",
                    "id": "4"
                },
                {
                    "label": 'Subglottic suction every 2 hourly',
                    "name": "subGlotticSuction",
                    "type": "checkbox",
                    "id": "5"
                },
                {
                    "label": 'Daily oral care with Chlorhexidene',
                    "name": "dailyOralCareWithChlorhexidene",
                    "type": "checkbox",
                    "id": "6"
                }];
        case BUNDLES_OPTION.CAUTI:
            return [
                {
                    "label": 'Perform a daily review of the need for the urinary catheter',
                    "name": "dailyReviewUrinaryCatheter",
                    "type": "checkbox",
                    "id": "1"
                },
                {
                    "label": 'Check the catheter has been continuously connected to the drainage system and secured',
                    "name": "catheterConnectedToDrainage",
                    "type": "checkbox",
                    "id": "2"
                },
                {
                    "label": 'Regularly empty urinary drainage bags as separate procedure, each into a clean container',
                    "name": "emptyUrinaryDrainageBags",
                    "type": "checkbox",
                    "id": "3"
                },
                {
                    "label": 'Ensure the bag is properly positioned (below bladder and not touching floor)',
                    "name": "postionOfBagWRTBladder",
                    "type": "checkbox",
                    "id": "4"
                },
                {
                    "label": 'Catheter site hygiene',
                    "name": "catheterSiteHygiene",
                    "type": "checkbox",
                    "id": "5"
                }];
        case BUNDLES_OPTION.CLABSI:
            return [
                {
                    "label": 'Hand hygiene',
                    "name": "handHygiene",
                    "type": "checkbox",
                    "id": "1"
                },
                {
                    "label": 'Maximal sterile barriers',
                    "name": "maximalSterileBarriers",
                    "type": "checkbox",
                    "id": "2"
                },
                {
                    "label": 'Chlorhexidine skin antisepsis',
                    "name": "chlorhexidineSkinAntisepsis",
                    "type": "checkbox",
                    "id": "3"
                },
                {
                    "label": 'Optimal catheter site selection',
                    "name": "optimalCatheterSiteSelection",
                    "type": "checkbox",
                    "id": "4"
                },
                {
                    "label": 'Daily review of line necessity',
                    "name": "dailyReviewOfLineNecessity",
                    "type": "checkbox",
                    "id": "5"
                },
                {
                    "label": 'Weekly dressing changes unless damp , loosened , or visibly soiled',
                    "name": "weeklyDressingChangesUnlessDamp",
                    "type": "checkbox",
                    "id": "6"
                },
                {
                    "label": 'Do not routinely replace CVCs solely for purposes of reducing the incident of infection',
                    "name": "replaceCVCsForReducingInfection",
                    "type": "checkbox",
                    "id": "7"
                },
                {
                    "label": 'Use an antimicrobial or antiseptic - impregnated CVC dressing',
                    "name": "antimicrobialCVCDressing",
                    "type": "checkbox",
                    "id": "8"
                },
                {
                    "label": 'Use of mechanical IV Valves',
                    "name": "mechanicalIVValves",
                    "type": "checkbox",
                    "id": "9"
                },
                {
                    "label": 'Minimize contamination risk by wiping the access port with an appropriate antiseptic',
                    "name": "minimizeContaminationByWiping",
                    "type": "checkbox",
                    "id": "10"
                }];
        default:
            return [];
    }
}

export const getParameterList = (type) => {

    switch (type) {
        case CHART_OPTIONS.VITALS:
            return [
                {
                    "label": "HR",
                    "name": "hr",
                    "id": "1",
                    "type": "number"
                }, {
                    "label": "SpO₂",
                    "name": "spo2",
                    "id": "2",
                    "type": "number"
                }, {
                    "label": "Temp",
                    "name": "temp",
                    "id": "3",
                    "type": "number"
                }, {
                    "label": "RR",
                    "name": "rr",
                    "id": "4",
                    "type": "number"
                }, {
                    "label": "NIBP (S)",
                    "name": "bpS",
                    "id": "5",
                    "type": "number"
                }, {
                    "label": "NIBP (D)",
                    "name": "bpD",
                    "id": "6",
                    "type": "number"
                }, {
                    "label": "NIBP (Mean)",
                    "name": "bpMean",
                    "id": "7",
                    "type": "number"
                }, {
                    "label": "Pulse Rate",
                    "name": "pulseRate",
                    "id": "8",
                    "type": "number"
                }];
        case CHART_OPTIONS.RS:
            return [
                {
                    "label": "Mode",
                    "name": "mode",
                    "id": "1",
                    "type": "text"
                }, {
                    "label": "FIO2",
                    "name": "fio2",
                    "id": "2",
                    "type": "number",
                }, {
                    "label": "Vent. Tidal Volume (Tv)",
                    "name": "setTv",
                    "id": "3",
                    "type": "number"
                }, {
                    "label": "PIP (Peak Inspiratory Pressure)",
                    "name": "pip",
                    "id": "4",
                    "type": "number"
                }, {
                    "label": "PEEP",
                    "name": "peep",
                    "id": "5",
                    "type": "number"
                }, {
                    "label": "MV (Minute Volume)",
                    "name": "setMv",
                    "id": "6",
                    "type": "number"
                }, {
                    "label": "Inhaled TV (VTi)",
                    "name": "vti",
                    "id": "7",
                    "type": "number"
                }, {
                    "label": "Exhaled TV (VTe)",
                    "name": "vte",
                    "id": "8",
                    "type": "number"
                }, {
                    "label": "PS (Pressure Support)",
                    "name": "ps",
                    "id": "9",
                    "type": "number"
                }, {
                    "label": "P Mean (Mean Pressure)",
                    "name": "pMean",
                    "id": "10",
                    "type": "number"
                }, {
                    "label": "I:E Ratio",
                    "name": "ie",
                    "id": "11",
                    "type": "text"
                }, {
                    "label": "Trigger",
                    "name": "trigger",
                    "id": "12",
                    "type": "number"
                }, {
                    "label": "Set Minute Volume",
                    "name": "mve",
                    "id": "13",
                    "type": "number"
                }, {
                    "label": "Cuff Pressure",
                    "name": "cuffPressure",
                    "id": "14",
                    "type": "number"
                },
                {
                    "label": "Respiratory Rate (RR)",
                    "name": "rr",
                    "id": "15",
                    "type": "number"
                },
                {
                    "label": "Peak Airway Pressure",
                    "name": "peakAirWayPressure",
                    "id": "16",
                    "type": "number"
                },
            ];
        case CHART_OPTIONS.CVS:
            return [
                {
                    "label": "RHYTHM",
                    "name": "rhythm",
                    "id": "1",
                    "type": "drop-down",
                    "height": "168px",
                    options: [
                        {
                            label: "Regular-Regular(R-R)",
                            name: "R-R",
                            id: "1"
                        },
                        {
                            label: "Regular-Irregular(R-I)",
                            name: "R-I",
                            id: "2"
                        },
                        {
                            label: "Irregular-Irregular(I-I)",
                            name: "I-I",
                            id: "3"
                        }
                    ]
                }, {
                    "label": "MAP",
                    "name": "map",
                    "id": "2",
                    "type": "number"
                }, {
                    "label": "CVP",
                    "name": "cvp",
                    "id": "3",
                    "type": "number"
                }];
        case CHART_OPTIONS.CNS:
            return [
                // {
                //     "label": "Eye Opening Response (A)",
                //     "name": "eyeOpeningResponse",
                //     "id": "1",
                //     "type": "drop-down"
                // }, {
                //     "label": "Verbal (B)",
                //     "name": "verbal",
                //     "id": "2",
                //     "type": "drop-down"
                // }, {
                //     "label": "Motor (C)",
                //     "name": "motor",
                //     "id": "3",
                //     "type": "drop-down"
                // }, {
                //     "label": "GCs (A+B+C)",
                //     "name": "gcs",
                //     "id": "4",
                //     "type": "drop-down"
                // }, 
                {
                    "label": "Pupil R - Size",
                    "name": "pupilRSize",
                    "id": "5",
                    "type": "drop-down",
                    "height": "188px",
                    options: [
                        {
                            name: "Normal",
                            label: "Normal",
                            id: "1"
                        },
                        {
                            name: "Small",
                            label: "Small",
                            id: "2"
                        },
                        {
                            name: "Large",
                            label: "Large",
                            id: "3"
                        },
                        {
                            name: "Pinpoint",
                            label: "Pinpoint",
                            id: "4"
                        },
                    ]
                }, {
                    "label": "Pupil L - Size",
                    "name": "pupilLSize",
                    "id": "6",
                    "type": "drop-down",
                    "height": "188px",
                    options: [
                        {
                            name: "Normal",
                            label: "Normal",
                            id: "1"
                        },
                        {
                            name: "Small",
                            label: "Small",
                            id: "2"
                        },
                        {
                            name: "Large",
                            label: "Large",
                            id: "3"
                        },
                        {
                            name: "Pinpoint",
                            label: "Pinpoint",
                            id: "4"
                        },
                    ]
                }, {
                    "label": "Pupil L - Reaction",
                    "name": "pupilLReaction",
                    "id": "7",
                    "type": "drop-down",
                    "height": "100px",
                    options: [
                        {
                            label: "Reactive(R)",
                            name: "R",
                            id: "1"
                        },
                        {
                            label: "Non-reactive(NR)",
                            name: "NR",
                            id: "2"
                        },
                    ]
                }, {
                    "label": "Pupil R - Reaction",
                    "name": "pupilRReaction",
                    "id": "8",
                    "type": "drop-down",
                    "height": "100px",
                    options: [
                        {
                            label: "Reactive(R)",
                            name: "R",
                            id: "1"
                        },
                        {
                            label: "Non-reactive(NR)",
                            name: "NR",
                            id: "2"
                        },
                    ]
                },
                {
                    "label": "Motor power LA | RA",
                    "name": "motorPowerLARA",
                    "id": "9",
                    "type": "drop-down",
                    "height": "380px",
                    options: [
                        {
                            "name": "G5",
                            "label": "Grade 5(G5)",
                            "id": "1"
                        },
                        {
                            "name": "G-4",
                            "label": "Grade -4(G-4)",
                            "id": "2"
                        },
                        {
                            "name": "G4",
                            "label": "Grade 4(G4)",
                            "id": "3"
                        },
                        {
                            "name": "G+4",
                            "label": "Grade +4(G+4)",
                            "id": "4"
                        },
                        {
                            "name": "G3",
                            "label": "Grade 3(G3)",
                            "id": "5"
                        },
                        {
                            "name": "G2",
                            "label": "Grade 2(G2)",
                            "id": "6"
                        },
                        {
                            "name": "G1",
                            "label": "Grade 1(G1)",
                            "id": "7"
                        },
                        {
                            "name": "G0",
                            "label": "Grade 0(G0)",
                            "id": "8"
                        },
                    ]
                },
                {
                    "label": "Motor power LL | RL",
                    "name": "motorPowerLLRL",
                    "id": "10",
                    "type": "drop-down",
                    "height": "380px",
                    options: [
                        {
                            "label": "Grade 5(G5)",
                            "name": "G5",
                            "id": "1"
                        },
                        {
                            "label": "Grade -4(G-4)",
                            "name": "G-4",
                            "id": "2"
                        },
                        {
                            "label": "Grade 4(G4)",
                            "name": "G4",
                            "id": "3"
                        },
                        {
                            "label": "Grade +4(G+4)",
                            "name": "G+4",
                            "id": "4"
                        },
                        {
                            "label": "Grade 3(G3)",
                            "name": "G3",
                            "id": "5"
                        },
                        {
                            "label": "Grade 2(G2)",
                            "name": "G2",
                            "id": "6"
                        },
                        {
                            "label": "Grade 1(G1)",
                            "name": "G1",
                            "id": "7"
                        },
                        {
                            "label": "Grade 0(G0)",
                            "name": "G0",
                            "id": "8"
                        },
                    ]
                },
                {
                    "name": "delirium",
                    "label": "Delirium",
                    "id": "9",
                    "height": "130px",
                    options: [
                        {
                            name: "Yes",
                            label: "Yes",
                            id: "1"
                        },
                        {
                            name: "No",
                            label: "No",
                            id: "2"
                        },
                        {
                            name: "Coma",
                            label: "Coma",
                            id: "3"
                        },
                    ]
                }
                // {
                //     "label": "Sedation Score",
                //     "name": "sedationScore",
                //     "id": "9",
                //     "type": "drop-down"
                // }, {
                //     "label": "Pain Score",
                //     "name": "painScore",
                //     "id": "10",
                //     "type": "drop-down"
                // }
            ];
        case CHART_OPTIONS.NURSING_CHECKS:
            return [
                {
                    "label": "User",
                    "name": "user",
                    "type": "text",
                    "id": "1"
                }, {
                    "label": "GlucoCheck",
                    "name": "glucoCheck",
                    "type": "checkbox",
                    "id": "2"
                }, {
                    "label": "Urine - Sugar",
                    "name": "urineSugar",
                    "type": "checkbox",
                    "id": "3"
                }, {
                    "label": "Urine - Ketone",
                    "name": "urineKetone",
                    "type": "double-checkbox",
                    "id": "4"
                }, {
                    "label": "Pressure Sore / Bed Sore",
                    "name": "pressureSoreBedSore",
                    "type": "checkbox",
                    "id": "5"
                }, {
                    "label": "Nebulization",
                    "name": "nebulization",
                    "type": "checkbox",
                    "id": "6"
                }, {
                    "label": "Positioning",
                    "name": "positioning",
                    "type": "checkbox",
                    "id": "7"
                }, {
                    "label": "CVC Care",
                    "name": "cvcCare",
                    "type": "checkbox",
                    "id": "8"
                }, {
                    "label": "Chest Physiotherapy",
                    "name": "chestPhysiotherapy",
                    "type": "checkbox",
                    "id": "9"
                }];
        case CHART_OPTIONS.I_O_BAL:
            return [{
                "label": IO_DATA.IO_ROWS.NAME,
                "id": "1",
            }, {
                "label": IO_DATA.IO_ROWS.TOTAL,
                "id": "2",
            }, {
                "label": "08:00",
                "id": "3",
            }, {
                "label": "09:00",
                "id": "4",
            }, {
                "label": "10:00",
                "id": "5",
            }, {
                "label": "11:00",
                "id": "6",
            }, {
                "label": "12:00",
                "id": "7",
            }, {
                "label": "13:00",
                "id": "8",
            }, {
                "label": "14:00",
                "id": "9",
            }, {
                "label": "15:00",
                "id": "10",
            }, {
                "label": "16:00",
                "id": "11",
            }, {
                "label": "17:00",
                "id": "12",
            }, {
                "label": "18:00",
                "id": "13",
            }, {
                "label": "19:00",
                "id": "14",
            }, {
                "label": "20:00",
                "id": "15",
            }, {
                "label": "21:00",
                "id": "16",
            }, {
                "label": "22:00",
                "id": "17",
            }, {
                "label": "23:00",
                "id": "18",
            }, {
                "label": "00:00",
                "id": "19",
            }, {
                "label": "01:00",
                "id": "20",
            }, {
                "label": "02:00",
                "id": "21",
            }, {
                "label": "03:00",
                "id": "22",
            }, {
                "label": "04:00",
                "id": "23",
            }, {
                "label": "05:00",
                "id": "24",
            }, {
                "label": "06:00",
                "id": "25",
            }, {
                "label": "07:00",
                "id": "26",
            }];
        case CHART_OPTIONS.CLINICAL_SCORES:
            return [
                {
                    "label": "SOFA",
                    "name": "sofa",
                    "id": "1"
                },
                {
                    "label": "GCS",
                    "name": "gcs",
                    "id": "2"
                },
                {
                    "label": "Risk Fall",
                    "name": "fallRisk",
                    "id": "3"
                },
                {
                    "label": "RASS",
                    "name": "rass",
                    "id": "4"
                },
                {
                    "label": "Braden",
                    "name": "braden",
                    "id": "5"
                },
                {
                    "label": "Apache II",
                    "name": "apache2",
                    "id": "6"
                },
            ];
        case CHART_OPTIONS.BUNDLES:
            return [{
                'name': 'VAP',
                'label': 'vap',
                'heading': 'VAP(Ventilator Associated Pneumonia)',
                'id': 1
            },
            {
                'name': 'CAUTI',
                'label': 'cauti',
                'heading': 'CAUTI (Catheter Associated Urinary Tract Infection)',
                'id': 2
            },
            {
                'name': 'CLABSI',
                'label': 'clabsi',
                'heading': 'CLASBI (Central Line Associated Blood Stream Infection)',
                'id': 3
            }];
        default:
            return [];
    }
}
/** patient details date picker
 * works in the exact same format
 * PLEASE DO NOT CHANGE
 */
export const DATE_FORMAT = {
    MOMENT_DATE_FORMAT: "MM-DD-YYYY",
    DATEPICKER_DATE_FORMAT: "dd-MM-yyyy",
}

export const dateFormat = "YYYY/MM/DD";
export const routeOptions = [
    { name: 'oral', label: 'Oral' },
    { name: 'iv', label: 'Intravenous (IV)' },
    { name: 'intrathecal', label: 'Intrathecal' },
    { name: 'sc', label: 'Subcutaneous (SC)' },
    { name: 'ng', label: 'Nasogastric (NG)' },
    { name: 'im', label: 'Intramuscular (IM)' },
    { name: 'sl', label: 'Sublingual (SL)' },
    { name: 'pr', label: 'Per Rectum (PR)' },
    { name: 'top', label: 'Topical (TOP)' },
    { name: 'pv', label: 'Per Vagina (PV)' },
];
export const drugNameOptions = [
    { name: 'dolo_365', label: 'Dolo 650 Tablet' },
    { name: 'dytor_injection', label: 'Dytor Injection' },
    { name: 'augmentin', label: 'Augmentin' },
    { name: 'pantop_d_capsule', label: 'Pantop-D Capsule' },
];

export const frequencyOptions = [
    { name: 'oid', label: 'OiD' },
    { name: 'bid', label: 'BiD' },
    { name: 'tid', label: 'TiD' },
    { name: 'qid', label: 'QiD' },
    { name: 'q4h', label: 'Q4H' },
    { name: 'q6h', label: 'Q6H' },
    { name: 'q8h', label: 'Q8H' },
];
export const durationOptions = [
    { name: '0.5', label: '0.5H' },
    { name: '1', label: '1H' },
    { name: '2', label: '2H' },
    { name: '3', label: '3H' },
    { name: '4', label: '4H' }
]

export const infusionOptions = [
    { name: 'Normal Saline', label: 'Normal Saline' },
    { name: 'Half Normal Saline', label: 'Half Normal Saline' },
    { name: 'Lactated Ringers', label: 'Lactated Ringers' },
    { name: 'Dextrose', label: 'Dextrose' },
];

export const additiveListOptions = [
    { name: "0.9% NaCl", label: "0.9% NaCl" },
    { name: "Dextrose 5%", label: "Dextrose 5%" },
    { name: "0.45% NaCl", label: "0.45% NaCl" },
]

export const getDownloadChartOption = (option) => {
    switch (option) {
        case CHART_OPTIONS.NURSING_CHECKS:
            return 'NURSING_CHECKS';
        case CHART_OPTIONS.CNS:
            return 'CNS';
        case CHART_OPTIONS.DRUG_ADMINISTRATION:
            return 'DRUG_ADMINISTRATION';
        case CHART_OPTIONS.RS:
            return 'RS';
        case CHART_OPTIONS.CVS:
            return 'CVS';
        case CHART_OPTIONS.VITALS:
            return 'VITALS';
        case CHART_OPTIONS.CLINICAL_SCORES:
            return 'CLINICAL_SCORES';
        case CHART_OPTIONS.I_O_BAL:
            return 'IO_BALANCE';
        case CHART_OPTIONS.LINES:
            return 'LINES';
        case CHART_OPTIONS.BUNDLES:
            return 'BUNDLES';
    }
}